import { StyleSheet } from 'react-native';
import { PALETTE } from "../../../../../../../src/constants";

export default StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    paddingTop: 3,
  },
  column: {
    flex: 1,
  },
  columnInner: {
    marginRight: 12,
  },
  leftAlignColumn: {
    flex: 1,
  },
  rightAlignColumn: {
    flex: 1,
    alignItems: 'flex-end',
  },
  assetItemDataChange:{
    color: PALETTE.paleBlue
  }
});
